import React, { FC, Ref } from 'react';
import { useStyles } from './styles';

export interface GroupProps {
  label: string;
  contentRef?: Ref<HTMLDivElement>;
}

const Group: FC<GroupProps> = ({ children, label, contentRef }) => {
  const styles = useStyles();

  return (
    <div className={styles.group}>
      <div className={styles.label}>{label}</div>
      <div ref={contentRef} className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default Group;
